export const ARTIFACT_TRANSCRIPT_SOURCE_TYPES = [
  'conversation_transcript',
  'transcript',
  'session_transcript',
] as const;

const artifactTranscriptSourceTypeSet = new Set<string>(ARTIFACT_TRANSCRIPT_SOURCE_TYPES);

export function isArtifactTranscriptSourceType(type: string | null | undefined): boolean {
  return artifactTranscriptSourceTypeSet.has(type?.trim().toLowerCase() ?? '');
}
